import { render, staticRenderFns } from "./UserHeadquartersSelector.vue?vue&type=template&id=12420216&scoped=true"
import script from "./UserHeadquartersSelector.vue?vue&type=script&lang=js"
export * from "./UserHeadquartersSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12420216",
  null
  
)

export default component.exports